import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { CalorieDial } from "../components/visuals/CalorieDial";

export default function NotFound() {
  return (
    <section className="relative isolate grid min-h-screen place-items-center overflow-hidden px-6 pt-20">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-teal/15 blur-3xl" />
      </div>
      <div className="text-center">
        <div className="mx-auto mb-8 w-fit opacity-90">
          <CalorieDial
            value={404}
            max={404}
            size={180}
            label="PAGE NOT FOUND"
            theme="light"
          />
        </div>
        <h1 className="display text-3xl text-navy sm:text-4xl">
          This page didn’t make the <span className="text-reward">bank.</span>
        </h1>
        <p className="mx-auto mt-4 max-w-md text-charcoal/70">
          The link you followed doesn’t exist — but your calorie bank is still
          waiting back home.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary px-6 py-3">
            <Home className="h-4 w-4" /> Back home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="btn-ghost px-6 py-3"
          >
            <ArrowLeft className="h-4 w-4" /> Go back
          </button>
        </div>
      </div>
    </section>
  );
}
